﻿'use strict'
import { App } from '../../config/app.js'
import { Modal } from '../../modal.js'
import { elementToggle, formTrackValidity, parseBool } from '../../helper.js'

export default function ()
{
	App.Modal.Coupon = new Modal('Coupon', {
		onOpen: async (modal, data) =>
		{
			modal.view.model.clear()
			if (data.id)
			{
				modal.element.setAttribute('ui-action', 'coupon update')
				modal.options.actionSubmitName = 'coupon update'
				modal.view.model.sync(await App.Store.fetch('coupon', data.id, { include: ['usage'] }))
			} else {
				modal.element.setAttribute('ui-action', 'coupon create')
				modal.options.actionSubmitName = 'coupon create'
				modal.view.render()
			}			
		},
		onActionAfter: (modal, e) =>
		{
			if (!e.detail.id)
				App.Store.pagingReset('coupon')
			modal.close() 
		}
	})
	document.addEventListener('action.before', function (e)
	{
		if (e.detail.name == 'coupon update' || e.detail.name == 'coupon create')
		{
			e.detail.data.startDateUtc = moment(e.detail.data.startDateUtc).startOf('day').toISOString()
			e.detail.data.endDateUtc = moment(e.detail.data.endDateUtc).endOf('day').toISOString()
		}
	})
	document.addEventListener('view.render', function (e)
	{
		if (e.detail.view.name == 'store/modalCoupon')
		{
			formTrackValidity(e.target) // needed because of the sync/re-render in onOpen
			e.target.querySelector('select[name="usePercentage"]').onchange = e =>
			{
				const usePercentage = parseBool(e.target.value)
				const amountGroup = e.target.closest('div.row').querySelector('div.input-group.discountAmount')
				const amount = amountGroup.querySelector('#couponModalDiscountAmount')
				const percentageGroup = e.target.closest('div.row').querySelector('div.input-group.discountPercentage')
				const percentage = percentageGroup.querySelector('#couponModalDiscountPercentage')
				elementToggle(e.target.closest('div.row').querySelector('label.discountAmount'), !usePercentage)
				elementToggle(amountGroup, !usePercentage)
				amount.min = usePercentage ? 0 : 0.01
				amount.value = 0
				elementToggle(e.target.closest('div.row').querySelector('label.discountPercentage'), usePercentage)
				elementToggle(percentageGroup, usePercentage)
				percentage.min = usePercentage ? 1 : 0
				percentage.value = 0
			}
			e.target.querySelector('select[name="discountLimitationId"]').onchange = e =>
			{
				const unlimited = parseInt(e.target.value) === 0
				const col = e.target.closest('div.discount-limitation')
				const row = col.closest('div.row')
				const timesCol = row.querySelector('div.limitation-times')
				const times = timesCol.querySelector('input[name="limitationTimes"]')
				if (unlimited)
				{
					col.classList.remove('col-sm-4')
					col.classList.add('col-sm-6')
					times.value = 1
				} else {
					col.classList.remove('col-sm-6')
					col.classList.add('col-sm-4')
				}
				elementToggle(timesCol, !unlimited)
			}
		}
	})
}
